import {TFunction} from 'i18next';
import {CemitTypename} from 'types/cemitTypename.ts';
import {
  DataThreshold,
  DataThresholdStyles,
  ZoomLevelValue,
} from 'types/dataVisualizations/dataThreshold';
import {clsOrTypes} from 'appUtils/typeUtils/clsOrTypes.ts';
import {HuntingAttributeAlertLevel} from 'types/alerts/hunting/huntingAttributeAlertLevel.ts';
import {
  CEMIT_ALERT_CRITICAL,
  CEMIT_ALERT_NORMAL,
  CEMIT_ALERT_WARNING,
} from 'theme/cemitColors.ts';
import {HuntingAttributeAlertSValue} from 'types/alerts/hunting/huntingAlertLevel.ts';

export const huntingDataThresholds = (t: TFunction) => {
  return clsOrTypes<DataThreshold>(CemitTypename.dataThreshold, [
    {
      sourceKey: HuntingAttributeAlertLevel.normal,
      label: t('lightHunting'),
      // Below RideComfortAttributeAlertSValue.warning
      value: HuntingAttributeAlertSValue.none,
      style: {
        color: CEMIT_ALERT_NORMAL,
        icon: 'ok',
        size: [
          // Always hidden
          {zoom: 0, outputValue: 0} as ZoomLevelValue,
          {zoom: 22, outputValue: 0} as ZoomLevelValue,
        ],
      } as Partial<DataThresholdStyles>,
    },
    {
      sourceKey: HuntingAttributeAlertLevel.warning,
      label: t('softHunting'),
      // from RideComfortAttributeAlertSValue.warning to RideComfortAttributeAlertSValue.critical
      value: HuntingAttributeAlertSValue.warning,
      iconConfigSize: 12,
      style: {
        color: CEMIT_ALERT_WARNING,
        icon: 'warning',
        size: [
          // For value warning, show these outputValues for circle-radius at each zoom level
          // TODO Keep the outputValue at 1 to prevent blurriness. We use the Svg image holder size
          // to make this icon bigger without blurring
          {zoom: 0, outputValue: 1} as ZoomLevelValue,
          {zoom: 22, outputValue: 1} as ZoomLevelValue,
        ],
      } as Partial<DataThresholdStyles>,
    },
    {
      sourceKey: HuntingAttributeAlertLevel.critical,
      label: t('hunting'),
      // All values above RideComfortAttributeAlertSValue.critical
      value: HuntingAttributeAlertSValue.critical,
      iconConfigSize: 15,
      style: {
        color: CEMIT_ALERT_CRITICAL,
        // TODO This icon name must match HuntingAttributeAlertLevel.critical because of the way
        // the code matches values to icons. It shouldn't be this way
        icon: 'critical',
        size: [
          // For value error, show these outputValues for circle-radius at each zoom level
          // TODO Keep the outputValue at 1 to prevent blurriness. We use the Svg image holder size
          // to make this icon bigger without blurring
          {zoom: 0, outputValue: 1} as ZoomLevelValue,
          {zoom: 22, outputValue: 1} as ZoomLevelValue,
        ],
      } as Partial<DataThresholdStyles>,
    },
  ]);
};
